import React from "react";
import AccountContent from "widgets/AccountContent";
import Header from "widgets/Header";

const Account: React.FC = () => {
  return (
    <main>
      <Header />

      <AccountContent />
    </main>
  );
};

export default Account;
